const BCPEmergency = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C14.125 21 16.078 20.2635 17.6177 19.0319L14.7574 16.1716C13.967 16.6951 13.0191 17 12 17C10.9809 17 10.033 16.6951 9.24261 16.1716L6.38231 19.0319C7.92199 20.2635 9.87499 21 12 21ZM4.9681 17.6177C3.73647 16.078 3 14.125 3 12C3 9.87499 3.73647 7.92199 4.9681 6.38231L7.8284 9.24261C7.30488 10.033 7 10.9809 7 12C7 13.0191 7.30488 13.967 7.8284 14.7574L4.9681 17.6177ZM21 12C21 14.125 20.2635 16.078 19.0319 17.6177L16.1716 14.7574C16.6951 13.967 17 13.0191 17 12C17 10.9809 16.6951 10.033 16.1716 9.24261L19.0319 6.38231C20.2635 7.92199 21 9.87499 21 12ZM17.6177 4.9681L14.7574 7.8284C13.967 7.30488 13.0191 7 12 7C10.9809 7 10.033 7.30488 9.24261 7.8284L6.38231 4.9681C7.92199 3.73647 9.87499 3 12 3C14.125 3 16.078 3.73647 17.6177 4.9681ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="#437EF7"
      />
      <mask
        id="mask0_3642_19009"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="22"
        height="22"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM12 21C14.125 21 16.078 20.2635 17.6177 19.0319L14.7574 16.1716C13.967 16.6951 13.0191 17 12 17C10.9809 17 10.033 16.6951 9.24261 16.1716L6.38231 19.0319C7.92199 20.2635 9.87499 21 12 21ZM4.9681 17.6177C3.73647 16.078 3 14.125 3 12C3 9.87499 3.73647 7.92199 4.9681 6.38231L7.8284 9.24261C7.30488 10.033 7 10.9809 7 12C7 13.0191 7.30488 13.967 7.8284 14.7574L4.9681 17.6177ZM21 12C21 14.125 20.2635 16.078 19.0319 17.6177L16.1716 14.7574C16.6951 13.967 17 13.0191 17 12C17 10.9809 16.6951 10.033 16.1716 9.24261L19.0319 6.38231C20.2635 7.92199 21 9.87499 21 12ZM17.6177 4.9681L14.7574 7.8284C13.967 7.30488 13.0191 7 12 7C10.9809 7 10.033 7.30488 9.24261 7.8284L6.38231 4.9681C7.92199 3.73647 9.87499 3 12 3C14.125 3 16.078 3.73647 17.6177 4.9681ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3642_19009)">
        <rect width="24" height="24" fill="#437EF7" />
      </g>
    </svg>
  );
};

export default BCPEmergency;
